import { memo, useMemo } from "react";
import { settingsOptimizationDefinitions } from "./optimizations";
import { useSettingsOptimizationManager } from "./use-settings-optimization";

export const SettingsOptimization = memo(function SettingsOptimization() {
  const { optimizationType, showOptimization, handleDismiss, handleComplete } =
    useSettingsOptimizationManager();

  const banner = useMemo(() => {
    if (!optimizationType || !showOptimization) {
      return null;
    }

    const definition = settingsOptimizationDefinitions[optimizationType];
    if (!definition) {
      return null;
    }

    const Component = definition.component;
    return (
      <Component
        handleComplete={handleComplete}
        handleDismiss={handleDismiss}
      />
    );
  }, [handleComplete, handleDismiss, optimizationType, showOptimization]);

  if (!banner) {
    return null;
  }

  return banner;
});
